import { render, staticRenderFns } from "./PurchaseReturnDetail.vue?vue&type=template&id=678f0aa5&scoped=true"
import script from "./PurchaseReturnDetail.vue?vue&type=script&lang=js"
export * from "./PurchaseReturnDetail.vue?vue&type=script&lang=js"
import style0 from "./PurchaseReturnDetail.vue?vue&type=style&index=0&id=678f0aa5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678f0aa5",
  null
  
)

export default component.exports